export class ReportEventCommand {
    eventId: string;
    reason: string;
    constructor(eventId: string, reason: string) {
        this.eventId = eventId;
        this.reason = reason;
    }
}
